import { ASINType, StateCode } from "./common";

export enum WaitlistSubscriptionStatus {
    ACTIVE = "ACTIVE",
    SUBSCRIPTION_NOT_FOUND = "SUBSCRIPTION_NOT_FOUND"
}

export interface WaitlistSubscription {
    readonly stateCode: StateCode
    readonly status: WaitlistSubscriptionStatus
}

export interface SubscribeToWaitlistSagaRequest {
    readonly stateCode: StateCode
    readonly asin: ASINType
}